import { Paper, Stack } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { NotForAdminsAlert } from '@/components/NotForAdminsAlert';
import { PageTitle } from '@/components/PageTitle';
import { BillingHistoryTable } from '@/components/subscriptions/BillingHistoryTable';
import { BillingProjectionSection } from '@/components/subscriptions/BillingProjectionSection';
import { PaymentTroubleAlert } from '@/components/subscriptions/PaymentTroubleAlert';

export const SubscriptionBillingHistory = () => {
    return (
        <Container maxWidth="lg">
            <PageTitle title="Billing History" />
            <NotForAdminsAlert />
            <Stack sx={{ mb: 3, width: 1, gap: 3 }}>
                <PaymentTroubleAlert />
                <BillingProjectionSection />
            </Stack>
            <Stack>
                <Typography variant="h3" sx={{ mb: 2 }}>
                    Invoices
                </Typography>
                <Paper elevation={0}>
                    <BillingHistoryTable />
                </Paper>
            </Stack>
        </Container>
    );
};
